import React from 'react'
import Header from '../components/Header'
import { Profile } from '../components/Profile'

export default function Profilepage() {
  return (
      <>
      <Header/>
      <Profile/>

      </>
  )
}
